<template>
  <a-card title="Danh sách quy trình" class="root-card">
    <div id="actions">
      <a-button type="primary" @click="handleFetchProcedures"><a-icon type="reload" /> Làm mới</a-button>
      <a-button type="default" style="margin-left: 15px" @click="selectImportFiles"><a-icon type="import" /> Import</a-button>
      <a-button type="default" style="margin-left: 15px" @click="exportProcedures"><a-icon type="export" /> Export</a-button>
      <a-button type="danger" style="margin-left: 15px" :disabled="tables.proceduresTable.selectedIds.length <= 0" @click="handleDeleteProcedures"><a-icon type="delete" /> Xóa</a-button>
    </div>
    <br />
    <a-table
      id="procedure-list-table"
      :columns="tables.proceduresTable.columns"
      :data-source="tables.proceduresTable.dataSource"
      :loading="loading.proceduresTable"
      :row-selection="tables.proceduresTable.rowSelection"
      :pagination="tables.proceduresTable.pagination"
      :scroll="{ y: 350 }"
    bordered>
      <div style="white-space: pre-wrap;" slot="description" slot-scope="description">{{description}}</div>
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="$router.push({ name: 'EditProcedure', params: { id: record.id }})"><a-icon type="edit" /> Sửa</a>
        <a-popconfirm
          style="margin-left: 15px"
          v-if="tables.proceduresTable.dataSource"
          title="Bạn có chắc muốn xóa quy trình này?"
          @confirm="() => handleDeleteProcedures([record.id])"
        >
          <a href="javascript:;" style="color: red"><a-icon type="delete" /> Xóa</a>
        </a-popconfirm>
      </template>
    </a-table>
    <input
      ref="importFileInput"
      type="file"
      multiple
      style="display: none"
      @change="handleImportProcedures"
    />
  </a-card>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

function downloadFile(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

const procedureListTableColumns = [
  {
    title: 'Tiêu đề',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: 'Mô tả',
    dataIndex: 'description',
    key: 'description',
    scopedSlots: { customRender: 'description' },
  },
  {
    title: 'Thao tác',
    scopedSlots: { customRender: 'operation' },
  }
]

export default {
  data() {
    return {
      tables: {
        proceduresTable: {
          columns: procedureListTableColumns,
          dataSource: [],
          selectedIds: [],
          rowSelection: {
            onChange: (selectedRowKeys, selectedRows) => {
              this.tables.proceduresTable.selectedIds = selectedRows.map(row => row.id);
            }
          },
          pagination: {
            showSizeChanger: true,
            pageSizeOptions: ['10', '30', '50', '100', '200', '500', '1000'],
            showQuickJumper: true,
            showTotal: (total, range) => {
              return `${range[0]} - ${range[1]} of ${total}`;
            }
          },
        }
      },
      loading: {
        proceduresTable: false,
        importProcedures: false
      }
    }
  },
  computed: {
    ...mapGetters('procedure', {
      procedures: "getProcedures"
    })
  },
  watch: {
    procedures(newProcedures) {
      this.tables.proceduresTable.dataSource = newProcedures;
    }
  },
  mounted() {
    this.handleFetchProcedures();
  },
  methods: {
    ...mapActions('procedure', {
      fetchProcedures: "fetchProcedures",
      deleteProcedures: "deleteProcedures",
      importProcedures: "importProcedures"
    }),

    async handleFetchProcedures() {
      this.loading.proceduresTable = true;
      await this.fetchProcedures();
      this.loading.proceduresTable = false;
    },

    handleDeleteProcedures(ids) {
      if (!ids || !Array.isArray(ids)) {
        ids = this.tables.proceduresTable.selectedIds;
      }

      const handler = async () => {
        const {message} = await this.deleteProcedures({ids});
        this.tables.proceduresTable.selectedIds = [];
        this.handleFetchProcedures();
        this.$message.success(message);
      }

      if (ids.length == 1) {
        handler();
        return;
      }

      if (ids.length > 1) {
        this.$confirm({
          title: 'Bạn có chắc muốn xóa những quy trình này?',
          content: 'Khi bạn click OK, dữ liệu sẽ bị xóa.',
          onOk: handler
        });
      }
    },

    exportProcedures() {
      const selectedIds = this.tables.proceduresTable.selectedIds;
      const procedures = (selectedIds.length == 0) ? this.procedures : this.procedures.filter(procedure => selectedIds.includes(procedure.id));

      downloadFile('procedures.json', JSON.stringify(procedures));
      this.$message.success('Xuất dữ liệu thành công!');
    },

    selectImportFiles() {
      this.$refs.importFileInput.click();
    },

    async handleImportProcedures(event) {
      this.loading.importProcedures = true;
      const files = event.target.files;
      
      try {
        const {message} = await this.importProcedures(files);
        this.$message.success(message);
        this.handleFetchProcedures();
      }
      catch(error) {
        this.$message.error(error?.response?.data?.error?.message || error?.response?.data || error?.message);
      }

      this.loading.importProcedures = false;
    }
  }
}
</script>
